import { CallStateEnum } from '@models/call-state.model.ts';
import {
  CallStateMethodNames,
  CallStateMethods
} from '@shared/store-features/call-state-feature.ts';
import { FieldValues } from 'react-hook-form';

export interface AuthState extends CallStateMethods {
  callState: CallStateEnum;
  switchHotelCallState: CallStateEnum;
  intervalId: NodeJS.Timeout | null;
  selectedHotelId: number | null;
  userRole: string | null;
  signIn: (body: FieldValues, navigate?: any) => void;
  signInCallStateError: string | null;
  refreshToken: () => void;
  startTokenRefreshInterval: () => void;
  stopTokenRefreshInterval: () => void;
  setCallState: (state: CallStateEnum) => void;
  logout: () => void;
  verifyBeforePasswordChange: (body: FieldValues, navigate?: any) => void;
  changePassword: (body: FieldValues) => void;
  switchHotel: (hotelId: any) => void;
  setSelectedHotelId: (hotelId: any) => void;
  isSwitchHotelLoading: () => boolean;
  isSwitchHotelLoaded: () => boolean;
  isSwitchHotelError: () => boolean;
  getUserBranding: (domain: string) => void;
}

interface AuthStateMethods extends CallStateMethodNames {
  signIn: 'signIn';
  switchHotel: 'switchHotel';
  refreshToken: 'refreshToken';
  startTokenRefreshInterval: 'startTokenRefreshInterval';
  stopTokenRefreshInterval: 'stopTokenRefreshInterval';
  logout: 'logout';
  setCallState: 'setCallState';
  verifyBeforePasswordChange: 'verifyBeforePasswordChange';
  changePassword: 'changePassword';
  isSwitchHotelLoading: 'isSwitchHotelLoading';
  isSwitchHotelLoaded: 'isSwitchHotelLoaded';
  isSwitchHotelError: 'isSwitchHotelError';
  setSelectedHotelId: 'setSelectedHotelId';
  getUserBranding: 'getUserBranding';
}

export const AUTH_INITIAL_STATE: Omit<AuthState, keyof AuthStateMethods> = {
  callState: CallStateEnum.Init,
  switchHotelCallState: CallStateEnum.Init,
  signInCallStateError: null,
  intervalId: null,
  selectedHotelId: null,
  userRole: null
};
